import { Controller } from '@hotwired/stimulus'
import { Toast } from 'bootstrap'

export default class extends Controller {
  static targets = ['toast']

  connect() {
    const toast = new Toast(this.toastTarget)
    toast.show()
  }
}
